import { derived, writable } from 'svelte/store';
import { location } from 'svelte-spa-router';

export const screen_width = writable(0);
export const screen_height = writable(0);
export const scroller_pos = writable(0);
export const is_mobile = writable(false);
export const is_tablet = writable(false);

export const routeParams = derived(location, ($location) => {
	const locationSplit = $location.split('/').filter(Boolean);
	return {
		id: locationSplit[1] === 'room' ? locationSplit[2] : '-1',
		type: locationSplit[0] === 'dash' ? locationSplit[0] : locationSplit[1],
	};
});
